import 'babel-polyfill';
import Vue from 'vue';

// Tailwind CSS for _new/ components
import '@new/styles/tailwind.css';
import vuetify from './plugins/vuetify';
import axios from 'axios';
import VueAxios from 'vue-axios';
// import VueFire from 'vuefire'
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import VueDayjs from 'vue-dayjs-plugin';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import duration from 'dayjs/plugin/duration';
import minMax from 'dayjs/plugin/minMax';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import 'dayjs/locale/ko';
import VueOffline from 'vue-offline';
import browserDetect from 'vue-browser-detect-plugin';
import VueCookies from 'vue-cookies';
import VueDragscroll from 'vue-dragscroll';
import AOS from 'aos';
import 'aos/dist/aos.css';
// import ScrollMagic from 'scrollmagic'
import VueScrollMagic from 'vue-scrollmagic';

import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import './filters';
import './directives';

import firebase from '@/config/firebase';
import validator from '@/config/validator';
import '@firebase/firestore';
// import './assets/scss/typo.scss'

// import Tawk from './plugins/tawkto'
import ChannelIO from './plugins/channelio';
import interceptor from './helpers/httpInterceptor.js';
import Inipay from './plugins/inipay';

import Hackle from './plugins/hackle.js';
import Mixpanel from './plugins/mixpanel.js';
import { pushDataLayer, getUtmParameters, getIpInfo } from './utils';
import { initSentry } from './plugins/sentry';
import { initWebVitals } from './plugins/web-vitals';

interceptor(axios);

// Day.js 플러그인 설정
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(minMax);
dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.locale('ko');

Vue.use(VueAxios, axios);
// Vue.use(VueFire);
Vue.use(VueLodash, { name: 'custom', lodash: lodash });
Vue.use(VueDayjs, {
  dayjs,
}); // Vue.dayjs(), this.$dayjs
Vue.use(VueOffline);
// Vue.use(Tawk, {
//   tawkSrc: 'https://embed.tawk.to/5c04fbd140105007f37ab6ff/default'
// });

if (process.env.VUE_APP_TARGET === 'campaign' || location.href.indexOf('superchart') > -1) {
  Vue.use(ChannelIO, {
    type: 'superchart',
  });
}

Vue.use(Hackle);

if (process.env.VUE_APP_TARGET === 'campaign') {
  Vue.use(Mixpanel);
}

Vue.use(browserDetect);
Vue.use(VueCookies);
Vue.use(Inipay);
Vue.use(VueScrollMagic, {
  verical: true,
  globalSceneOptions: {},
  loglevel: 2,
  refreshInterval: 100,
});

Vue.use(VueDragscroll);

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
Vue.config.productionTip = false;

validator();

Vue.prototype.$categories = {
  매장: { loc: 'store' },
  제품: { loc: 'product' },
  서비스: { loc: 'service' },
};
Vue.prototype.$channel = ['naver', 'insta', 'youtube'];
Vue.prototype.$forceCompute = function (computedName, forceUpdate /* default: true */) {
  if (this._computedWatchers[computedName]) {
    this._computedWatchers[computedName].run();
    if (forceUpdate || typeof forceUpdate == 'undefined') this.$forceUpdate();
  }
};
Vue.prototype.$periodMap = {
  naver: {
    T: {
      매장: [7, 10, 5, 5, 3], //방문기한, 첫원고, 수정요청기한, 수정사항 반영 업로드 기한, 업로드 요청일로부터 리뷰 등록기한
      제품: [7, 10, 5, 5, 3],
      서비스: [7, 10, 5, 5, 3],
    },
    P: {
      매장: [3, 10, 5, 5, 3],
      제품: [3, 10, 5, 5, 3],
      서비스: [3, 10, 5, 5, 3],
    },
  },
  insta: {
    T: {
      매장: [7, 10, 5, 5, 3],
      제품: [7, 10, 5, 5, 3],
      서비스: [7, 10, 5, 5, 3],
    },
    P: {
      매장: [3, 10, 5, 5, 3],
      제품: [3, 10, 5, 5, 3],
      서비스: [3, 10, 5, 5, 3],
    },
  },
  youtube: {
    T: {
      매장: [7, 21, 5, 7, 3],
      제품: [7, 21, 5, 7, 3],
      서비스: [7, 21, 5, 7, 3],
    },
    P: {
      매장: [3, 21, 5, 7, 3],
      제품: [3, 21, 5, 7, 3],
      서비스: [3, 21, 5, 7, 3],
    },
  },
};

Vue.prototype.$requiredMap = {
  naver: {
    T: ['mission', 'requiredKeywords', 'keywords'],
    P: ['mission', 'requiredKeywords', 'keywords'],
  },
  youtube: {
    T: ['mission', 'requiredKeywords', 'keywords'],
    P: ['mission', 'requiredKeywords', 'keywords'],
  },
  매장: {
    T: ['local', 'serviceName', 'address', 'contacts', 'abstraction', 'introduction', 'thumbnail', 'thumbnails'],
    P: ['local', 'serviceName', 'address', 'contacts', 'abstraction', 'introduction', 'thumbnail', 'thumbnails'],
  },
  제품: {
    T: [
      'serviceName',
      'contacts',
      'companyName',
      'abstraction',
      'introduction',
      'deliveryMethod',
      'shipping',
      'thumbnail',
      'thumbnails',
    ],
    P: ['serviceName', 'abstraction', 'introduction', 'thumbnail', 'thumbnails'],
  },
  서비스: {
    T: ['serviceName', 'abstraction', 'introduction', 'thumbnail', 'thumbnails'],
    P: ['serviceName', 'abstraction', 'introduction', 'thumbnail', 'thumbnails'],
  },
};
Vue.prototype.$getMaxEditCount = function (price, channel) {
  let maxEditCount = 3;
  if (channel === 'youtube') {
    if (price < 1000000 || price === undefined) {
      maxEditCount = 1;
    } else if (price < 3000000) {
      maxEditCount = 2;
    }
  } else {
    if (price < 50000 || price === undefined) {
      maxEditCount = 1;
    } else if (price < 1000000) {
      maxEditCount = 2;
    }
  }
  return maxEditCount;
};

Vue.prototype.$minYoutubeProposeRate = 0.2;
Vue.prototype.$minProposeRate = 0.5;
Vue.prototype.$maxProposeRate = 5;
Vue.prototype.$maxProposeRate2 = 10;

export const gEventBus = new Vue();

initSentry(Vue, router);
initWebVitals();

// 패키지 방식 Sentry가 Vue 에러/Promise를 자동 후킹합니다.

new Vue({
  // sockets: {
  //   connect: function () {
  //     console.log('socket connected')
  //   },
  //   login: function (data) {
  //     if (store.getters.user && (data.email === store.getters.user.email)) {
  //       console.log('logout')
  //       // message and logout
  //       store.commit('setMsg', '중복 로그인으로 로그아웃 됩니다.');
  //       store.commit('setShowSnackbar', true);
  //       store.dispatch('logout');
  //     }
  //   }
  // },
  router,
  store,
  vuetify,
  beforeCreate() {
    store.commit('setAuthInited', false);
  },
  async created() {
    process.argv.forEach((val, index) => {
      console.log(`${index}: ${val}`);
    });
    store.commit('setLoading', true);
    let isFirstAuthCheck = true;
    firebase.app.auth().onAuthStateChanged(async user => {
      store.commit('setAuthInited', true);
      store.commit('setLoading', false);

      const utmParams = getUtmParameters();
      const ip = await getIpInfo();
      const webVersion = process.env.VUE_APP_VERSION;

      if (user) {
        if (
          (user.email.indexOf('@supermembers.co.kr') > 0 && (store.getters.user || {}).email !== user.email) ||
          (store.getters.user || {}).email !== (store.getters.head || {}).email
        ) {
          await store.dispatch('autoSignIn', {
            email: (store.getters.user || {}).email || user.email,
            uid: null,
            matching: this.isMatching(),
          });
        } else {
          await store.dispatch('autoSignIn', { ...user, matching: this.isMatching() });
        }

        const storeUser = store.getters.user;

        this.updateHackleCommonProperties(storeUser);

        // MIXPANEL 공통 변수 세팅
        if (storeUser?.id) {
          pushDataLayer({
            event: 'mixpanelIdentifyUser',
            userId: storeUser.id,
          });

          const properties = {
            service: process.env.VUE_APP_TARGET === 'campaign' ? 'superchart' : 'supermembers',
            webVersion,
            userId: storeUser.id,
            clientAccessTime: new Date().toISOString(),
            createdAt: storeUser.createdAt,
            agreeToMarketing: storeUser.agree_to_mail,
            isMember: true,
            isStaff: storeUser.is_staff ? true : false,
            companyName: storeUser.name,
            ip,
            ...utmParams,
          };

          pushDataLayer({
            event: 'mixpanelRegisterUser',
            ...properties,
          });
        }

        // 라우팅 로직
        if (this.$route.name === 'Matching') {
          router.push('/campaign/search');
        } else if (this.$route.name === undefined || this.$route.name === 'Landing') {
          router.push('/company/report');
        }
      } else {
        // 로그아웃 상태 처리 (이미 로그아웃 상태면 스킵)
        if (store.getters.user !== null) {
          await store.dispatch('logout');
        }

        this.resetHackleCommonProperties();

        // 최초 방문이 아닌 실제 로그아웃인 경우에만 reset 호출
        if (!isFirstAuthCheck) {
          pushDataLayer({
            event: 'mixpanelResetUser',
          });
        }

        // Default Properties
        const properties = {
          service: process.env.VUE_APP_TARGET === 'campaign' ? 'superchart' : 'supermembers',
          webVersion,
          clientAccessTime: new Date().toISOString(),
          isMember: false,
          isStaff: false,
          ip,
          ...utmParams,
        };

        pushDataLayer({
          event: 'mixpanelRegisterUser',
          ...properties,
        });

        let requiresAuth = this.$route.matched.some(record => record.meta.requiresAuth);
        if (requiresAuth) {
          router.push('/signin');
        }
      }
      isFirstAuthCheck = false;
    });
  },
  render: h => h(App),
  mounted() {
    AOS.init({
      offset: 120,
      duration: 400,
      easing: 'ease-out-quad',
    });
  },
  methods: {
    isMatching() {
      return process.env.VUE_APP_TARGET === 'campaign' || location.href.indexOf('superchart') > -1;
    },
  },
}).$mount('#app');
